import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import Tab from "react-bootstrap/Tab";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main() {
  
  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Annual Reports" />
      <section className="project-detail">
        <div className="container">
        
          <Row>

            
            
            <Col md={6} className="c-left">
                <div className="'my-5 services-box lin'">
                  <div className="c-heading">
                    <h4 >Annual Reports </h4>
                  </div>
                    <table className="table table-striped">
                      <tbody>
                           <tr>
                              <td>Annual Report 2024-25</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/Annual_Report_2024_25.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/Hindi_Annual_Report_2024_25.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2023-24</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/Annual_Report_2023_24_Latest.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/Hindi_Annual_Report_2023_24.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2022-23</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/Annual_Report_2023.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/Hindi_Annual_Report_2023.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2021-22</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/IIT%20Annual%20Report%202021-2022.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/IIT%20Hindi_Annual%20Report%202021-2022.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                          
                              <td>Annual Report 2020-21</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/IIT%20English%202020-2021.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/IITHindi%20Annual%20Rept%202020-21.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2019-20</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/Annual%20Report%202019-20%20IITT.pdf" target="_blank">English Version</Link></td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/Annual%20Report%202019-20%20IITT.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2018-19</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/English%20Annnual%20Rept%2018-19.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/Hindi%20Annual%20Rept%2018-19.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2017-18</td>
                              <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/IITTEnglishAnnualReport17-18.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/IITTHindiAnnualReport17-18.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2016-17</td>
                              <td> <Link to="https://files.iittp.ac.in/images/demo/iit/pdfs/annualreport/AnnualReportEnglish2016-2017.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/images/demo/iit/pdfs/annualreport/AnnualReportHindi2016-2017.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          <tr>
                              <td>Annual Report 2015-16</td>
                              <td> <Link to="https://files.iittp.ac.in/images/demo/iit/pdfs/annualreport/AT-TIP-English.pdf" target="_blank">English Version</Link></td>
                              <td><Link to="https://files.iittp.ac.in/images/demo/iit/pdfs/annualreport/AT-Trp_Hindi.pdf" target="_blank">Hindi Version</Link></td>
                          </tr>
                          
                      </tbody>
                      
                      
                    </table>
              </div>
            </Col>

            <Col md={6} className="c-left">
            <div className="'my-5 services-box lin'">
              <div className="c-heading">
                <h4>Annual Accounts</h4>
              </div>
              <table className="table table-striped">
                <tbody>
                  <tr>
                    <td>Annual Accounts 2024-2025</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2024-25_08_12_25.pdf" target="_blank">English Version</Link></td>
                    <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_Hindi_2024-25_08_12_25.pdf" target="_blank">Hindi Version</Link></td>
                  </tr>
                <tr>
                    <td>Annual Accounts 2023-2024</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2023-24_23_5_25.pdf" target="_blank">English Version</Link></td>
                    <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2023-24_Hindi.pdf" target="_blank">Hindi Version</Link></td>
                  </tr>
                  <tr>
                    <td>Annual Accounts 2022-2023</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2022-23.pdf" target="_blank">English Version</Link></td>
                    <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2022-23_Hindi.pdf" target="_blank">Hindi Version</Link></td>                 
                   </tr>
                  <tr>
                    <td>Annual Accounts 2021-2022</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2021-22.pdf" target="_blank">English Version</Link></td>
                    <td><Link to="#"> - </Link></td> 
                  </tr>
                  <tr>
                    <td>Annual Accounts 2020-2021</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2020-2021.pdf" target="_blank">English Version</Link></td>
                    <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2020-21_Hindi.pdf" target="_blank"> Hindi Version </Link></td> 
                  </tr>
                  <tr>
                    <td>Annual Accounts 2019-2020</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2019-2020.pdf"target="_blank">English Version</Link></td>
                    <td><Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2019-20_Hindi.pdf" target="_blank">Hindi Version</Link></td>
                  </tr>
                  <tr>
                    <td>Annual Accounts 2018-2019</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2018-2019.pdf"target="_blank">English Version</Link></td>
                    <td><Link to="#"> - </Link></td>
                  </tr>
                  <tr>
                    <td>Annual Accounts 2017-2018</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2017-18.pdf"target="_blank">English Version</Link></td>
                    <td><Link to="#"> - </Link></td>
                  </tr>
                  <tr>
                    <td>Annual Accounts 2016-2017</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2016-2017.pdf"target="_blank">English Version</Link></td>
                    <td><Link to="#"> - </Link></td>
                  </tr>
                  <tr>
                    <td>Annual Accounts 2015-2016</td>
                    <td> <Link to="https://files.iittp.ac.in/pdfs/annualreport/accounts/Annual_Accounts_2015-16.pdf"target="_blank">English Version</Link></td>
                    <td><Link to="#"> - </Link></td>
                  </tr>
                  
                </tbody>
                
                
              </table>
              </div>
              
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
